import CorrectIcon from "@icons/learning_adaptive_correct.svg";
import WrongIcon from "@icons/learning_adaptive_wrong.svg";
import FinishIcon from "@icons/learning_adaptive_finish_test.svg";
import styles from "./learningAdaptiveTestFinal.module.scss";
import { Panel } from "@kunduz/ui";

export const LearningAdaptiveTestFinal = (props: Props) => {
  const {
    testInfo: { wrongCount, correctCount },
    referrer,
    title,
    description,
    backToCourseButtonLabel,
  } = props;

  return (
    <Panel className={styles["container"]}>
      <div className={styles["title"]}>{title}</div>
      <div className={styles["description"]}>{description}</div>
      <div className={styles["iconsContainer"]}>
        <div>
          <div className={styles["iconContainer"]}>
            <img src={CorrectIcon} alt="correct" />
            <span>{correctCount}</span>
          </div>
          <div className={styles["iconContainer"]}>
            <img src={WrongIcon} alt="wrong" />
            <span>{wrongCount}</span>
          </div>
        </div>
        <img src={FinishIcon} alt="finish" />
      </div>
      <a href={`/${referrer}/`} className={styles["button"]}>
        {backToCourseButtonLabel}
      </a>
    </Panel>
  );
};

interface Props {
  testInfo: {
    wrongCount: number;
    correctCount: number;
  };
  referrer: string;
  title: string;
  description: string;
  backToCourseButtonLabel: string;
}
